import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle1" }, " Are you sure you want to trash this post? ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_post = _resolveComponent("post")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Trash Post",
    size: "xs",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_q_btn, {
        label: "Trash",
        color: "negative",
        class: _normalizeClass(_ctx.gtm.TRASH_POST),
        onClick: _ctx.trash
      }, null, 8, ["class", "onClick"])
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_post, { post: _ctx.post }, null, 8, ["post"])
    ]),
    _: 1
  }, 512))
}